function DashboardIcon({ color = '#FFFEFE', size = '16', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.13889C0.86193 8.13889 0.75 8.02696 0.75 7.88889V1C0.75 0.861928 0.861929 0.75 1 0.75H6.11111C6.24918 0.75 6.36111 0.861929 6.36111 1V7.88889C6.36111 8.02696 6.24918 8.13889 6.11111 8.13889H1ZM1 15.25C0.861929 15.25 0.75 15.1381 0.75 15V11.6667C0.75 11.5286 0.861929 11.4167 1 11.4167H6.11111C6.24918 11.4167 6.36111 11.5286 6.36111 11.6667V15C6.36111 15.1381 6.24918 15.25 6.11111 15.25H1ZM9.88889 15.25C9.75082 15.25 9.63889 15.1381 9.63889 15V8.11111C9.63889 7.97304 9.75082 7.86111 9.88889 7.86111H15C15.1381 7.86111 15.25 7.97304 15.25 8.11111V15C15.25 15.1381 15.1381 15.25 15 15.25H9.88889ZM9.63889 1C9.63889 0.861928 9.75082 0.75 9.88889 0.75H15C15.1381 0.75 15.25 0.861928 15.25 1V4.33333C15.25 4.47141 15.1381 4.58333 15 4.58333H9.88889C9.75082 4.58333 9.63889 4.47141 9.63889 4.33333V1Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default DashboardIcon;
